<template>
  <nav class="navbar navbar-expand-lg navbar-absolute navbar-transparent">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
        </div>
        <div class="navbar-toggle d-inline">
          <button type="button" class="navbar-toggler">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <router-link to="/" class="navbar-brand">
          <img :src="logo" id="navbar-logo"/>
        </router-link>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <router-link to="/refetch" class="nav-link active">
          Refetch Adjust Costs
        </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/influencer-costs" class="nav-link active">
          Upload Influencer Costs
        </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/influencer-monthly-costs" class="nav-link active">
          Upload Influencer Monthly Costs
        </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/upload-coupon" class="nav-link active">
          Upload Coupon
        </router-link>
        </li>
        </ul>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav ml-auto">
          <li class="dropdown nav-item">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <i class="fas fa-user"></i>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                Log out
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <li class="nav-link">
                <a href="javascript:void(0)" class="nav-item dropdown-item" @click="signOut()"
                  >Log out</a
                >
              </li>
            </ul>
          </li>
          <li class="separator d-lg-none"></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import tokenManagerService from '../services/tokenManager'

export default {
    name: 'HeaderNav',
    methods: {
        signOut() {
          tokenManagerService.logout()
        }
    },
    computed: {
      logo() {
        if (this.$route.name == "CatalogManager"){
          const appId = this.$route.params.id
          return require(`@/assets/images/${appId}.png`)
        }else{
          return require('@/assets/images/logo.png')
        }
      }
    }
}
</script>

<style>
#navbar-logo {
  width: 40px;
}
</style>